/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Isir_Active_OnlyInputs */

const cs_property_registry_isir_active_only = /** @type {(inputs: Property_Registry_Isir_Active_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen aktuální řízení`)
};

const en_property_registry_isir_active_only = /** @type {(inputs: Property_Registry_Isir_Active_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active cases only`)
};

/**
* | output |
* | --- |
* | "Active cases only" |
*
* @param {Property_Registry_Isir_Active_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_isir_active_only = /** @type {((inputs?: Property_Registry_Isir_Active_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Isir_Active_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_isir_active_only(inputs)
	return cs_property_registry_isir_active_only(inputs)
});